<template>
  <!-- 补充毕业材料弹窗 -->
  <a-modal
    :width="580"
    :visible="visible"
    title="补充毕业材料"
    centered
    @cancel="cancel"
  >
    <div class="content_box">
      <a-form
        ref="formBox"
        :model="formData"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item
          label="证件照"
          name="idPhoto"
          :rules="[{ required: true, message: '请上传图片' }]"
        >
          <div class="img-list flex-container">
            <div v-if="formData.idPhoto" class="img-box">
              <a-image :src="formData.idPhoto" alt="avatar" />
              <div class="remove-img" @click.stop="handleRemove('idPhoto')">
                <close-circle-filled />
              </div>
            </div>
            <a-upload
              v-else
              name="avatar"
              list-type="picture-card"
              accept=".jpg"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="(event) => beforeUpload(event, 1)"
              :customRequest="(event) => onCustomRequest(event, 'idPhoto')"
            >
              <div>
                <div>
                  <loading-outlined
                    style="color: rgba(0, 0, 0, 0.85)"
                    v-if="state.uploadLoading"
                  ></loading-outlined>
                  <plus-outlined
                    style="color: rgba(0, 0, 0, 0.85)"
                    v-else
                  ></plus-outlined>
                </div>
                <div>上传</div>
              </div>
            </a-upload>
            <div>
              <a-tooltip
                placement="topLeft"
                :overlayStyle="{ maxWidth: '300px' }"
              >
                <template #title>
                  <div class="img-list-tips">
                    1、学生本人近期免冠数码报名照片（即标准证件照）；
                    <br />
                    2、照片的背景色为蓝底；
                    <br />
                    3、照片上着装的颜色应避开与背景相同色调，且无佩饰；
                    <br />
                    4、照片尺寸为480x640像素，分辨率为300DPI以上的JPG文件,不大于300kb；
                    <br />
                    5、请勿上传风景照片；翻拍或扫描的照片、大头照等不符合规定的照片。
                  </div>
                </template>
                <span class="img-tips">查看免冠证件照要求</span>
                <div style="margin-left: 8px">
                  照片须与省考试院毕业申请照片一致
                </div>
              </a-tooltip>
            </div>
          </div>
        </a-form-item>
        <a-form-item
          label="自考毕业证号"
          name="selfStudyCertificateNumber"
          :rules="[{ required: true, message: '自考毕业证号' }]"
        >
          <a-input
            v-model:value.trim="formData.selfStudyCertificateNumber"
            placeholder="请输入自考毕业证号"
            :maxlength="20"
          />
        </a-form-item>
        <a-form-item
          name="moeRegistration"
          :rules="[{ required: true, message: '请上传图片' }]"
        >
          <template #label>
            <a-tooltip
              placement="topLeft"
              :overlayStyle="{ maxWidth: '300px' }"
            >
              <span>教育部学历证书电子注册备案表</span>
              <span>
                <a-tooltip
                  placement="top"
                  :overlayStyle="{ maxWidth: '300px' }"
                >
                  <template #title>
                    <span style="color: #fff">
                      若未毕业，需上传申请毕业截图
                      <br />
                      若已毕业，则前往学信网下载电子注册备案表
                      <br />
                      *详见示例图
                    </span>
                  </template>
                  <info-circle-outlined style="margin: 0 5px" />
                </a-tooltip>
              </span>
            </a-tooltip>
          </template>
          <a-popover trigger="click" placement="bottomLeft">
            <template #content>
              <div style="display: flex">
                <div>
                  <div>申请毕业截图</div>
                  <a-image
                    :width="200"
                    :src="require('@/assets/example/moeRegistration1.png')"
                  />
                </div>
                <div>
                  <div>毕业备案表</div>
                  <a-image
                    :width="200"
                    :src="require('@/assets/example/moeRegistration2.png')"
                  />
                </div>
              </div>
            </template>
            <div class="check-example top-67">查看示例图</div>
          </a-popover>
          <div class="img-list">
            <div v-if="formData.moeRegistration" class="img-box">
              <a-image :src="formData.moeRegistration" alt="avatar" />
              <div
                class="remove-img"
                @click.stop="handleRemove('moeRegistration')"
              >
                <close-circle-filled />
              </div>
            </div>
            <a-upload
              v-else
              name="avatar"
              list-type="picture-card"
              accept=".jpg"
              class="avatar-uploader"
              :show-upload-list="false"
              :before-upload="beforeUpload"
              :customRequest="
                (event) => onCustomRequest(event, 'moeRegistration')
              "
            >
              <div>
                <div>
                  <loading-outlined
                    style="color: rgba(0, 0, 0, 0.85)"
                    v-if="state.uploadLoading"
                  ></loading-outlined>
                  <plus-outlined
                    style="color: rgba(0, 0, 0, 0.85)"
                    v-else
                  ></plus-outlined>
                </div>
                <div>上传</div>
              </div>
            </a-upload>
          </div>
        </a-form-item>
      </a-form>
    </div>
    <template #footer>
      <a-button style="margin-right: 5px" @click="cancel">取消</a-button>
      <a-button type="primary" @click="handleOk" :loading="state.loading">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { ref, reactive, watch } from "vue";
import { message, Modal } from "ant-design-vue";

import {
  PlusOutlined,
  LoadingOutlined,
  CloseCircleFilled,
  InfoCircleOutlined,
} from "@ant-design/icons-vue";
import { updatePaperApplyRecordDocument } from "@/api/paper.js";
import { updatePaperStudentMajorDocument } from "@/api/my_page/paper/index.js";
import { sdkOssUpimage } from "@/api/common.js";
import { getGuId } from "@/utils/function";
import { getOther } from "@/api/common-paper.js";
import {
  getUserAccount,
  getStudentAccount,
} from "@/api/my_page/student_info/index.js";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  id: {
    type: [Number, String],
    default: "",
  },
  type: {
    type: String,
    default: "",
  },
  data: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
const emit = defineEmits(["update:visible", "updateList", "cancel"]);

let state = reactive({
  loading: false,
  btnLoading: false,
});
const formBox = ref(null);
const formData = reactive({
  outline: "",
  fileUrl: "",
});
const labelCol = {
  span: 6,
};
const wrapperCol = {
  span: 16,
};

watch(
  () => props.visible,
  (newVal) => {
    if (newVal) {
      getDetails();
    } else {
      state.fileList = [];
      formBox.value.resetFields();
    }
  },
  { deep: true }
);

const getDetails = async () => {
  try {
    let res2 = {};
    if (props.type == "dissertation") {
      res2 = await getStudentAccount();
    } else {
      let res = await getUserAccount();
      Object.assign(formData, res);
      res2 = await getOther(props.data.paperApplyRecordId);
    }
    Object.assign(formData, res2);
  } catch (error) {
    console.log(error);
  }
};

// 上传文件（待优化）
const onCustomRequest = async (e, type) => {
  const file = e.file;

  if (type == "idPhoto") {
    // 创建一个 FileReader 对象来读取文件
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        if (img.width === 480 && img.height === 640) {
          // 图片尺寸符合要求
          uploadFile(file, type);
        } else {
          // 图片尺寸不符合要求
          formData[`${type}List`] = [];
          formData[type] = undefined;
          message.error("图片尺寸必须为 480x640 像素");
        }
      };
      img.onerror = () => {
        message.error("图片加载失败");
      };
      img.src = event.target.result;
    };

    reader.onerror = () => {
      message.error("文件读取失败");
    };

    reader.readAsDataURL(file);
  } else {
    uploadFile(file, type);
  }
};
const uploadFile = async (file, type) => {
  //   state.uploadLoading = true;
  let client = await sdkOssUpimage();
  const fileName = `${client.options.env}/student/${getGuId()}_${file.name}`;
  client.put(fileName, file).then((result) => {
    formData[type] = result.url;
    handleValidate(type);
    // state.uploadLoading = false;
  });
};

/**
 * 移除文件
 **/
const handleRemove = (type) => {
  formData[type] = "";
};

/**
 * 校验当前字段
 **/
const handleValidate = (type) => {
  formBox.value.validate(type);
};

/**
 * 图片上传前的回调
 **/
const beforeUpload = (file, type = 2) => {
  const isJpgOrPng = file.type === "image/jpeg";
  if (!isJpgOrPng) {
    message.error("请上传jpeg格式的文件!");
  }

  let isMaxSize = undefined;

  if (type == 1) {
    isMaxSize = file.size / 1024 < 300;
    if (!isMaxSize) {
      message.error("图片大小不得超过300Kb!");
    }
  } else {
    isMaxSize = file.size / 1024 / 1024 < 1;
    if (!isMaxSize) {
      message.error("图片大小不得超过1MB!");
    }
  }

  return isJpgOrPng && isMaxSize;
};

// 点击确定
function handleOk() {
  formBox.value.validate().then(() => {
    Modal.confirm({
      title: "提示",
      content:
        "请认真核对提交的材料内容，如有错误，会导致学位申请失败；提交后不可修改，请确认后提交。",
      onOk: async () => {
        const { selfStudyCertificateNumber, moeRegistration, idPhoto } =
          formData;
        state.loading = true;
        try {
          let params = {
            selfStudyCertificateNumber,
            moeRegistration,
            idPhoto,
          };
          if (props.type == "dissertation") {
            params.id = props.id;
            await updatePaperStudentMajorDocument(params);
          } else {
            params.paperApplyRecordId = props.id;
            await updatePaperApplyRecordDocument(params);
          }
          state.loading = false;
          emit("update:visible", false);
          updateList();
        } catch (e) {
          console.log(e);
          state.loading = false;
        }
      },
    });
  });
}

// 取消
function cancel() {
  emit("update:visible", false);
  emit("cancel");
}

function updateList() {
  emit("updateList");
}
</script>

<style lang="less" scoped>
.content_box {
  width: 100%;

  :deep(.ant-form) {
    .ant-form-item-required {
      white-space: normal;
    }
    label {
      min-height: 32px;
      height: auto;
    }
  }

  .img-list {
    position: relative;
    margin-right: 16px;

    .img-box {
      position: relative;
      width: 94px;
      height: 124px;
      border: 1px dashed #d9d9d9;
      &:hover {
        .remove-img {
          opacity: 1;
        }
      }
      :deep(.ant-image) {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%);
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .remove-img {
        position: absolute;
        top: -7px;
        right: -7px;
        width: 14px;
        height: 14px;
        opacity: 0;
        transition: opacity 0.3s;
        span {
          color: red;
          font-size: 14px;
          line-height: 0;
          background: #fff;
          border-radius: 10px;
          cursor: pointer;
        }
      }
    }
    .avatar-uploader {
      width: auto;
      :deep(.ant-upload) {
        width: 94px;
        height: 124px;
        margin: 0;
      }
    }
    .idcard-uploader {
      width: auto;
      :deep(.ant-upload) {
        width: 164px;
        height: 94px;
        margin: 0;
      }
    }
    .img-picture {
      width: 164px;
      height: 94px;
    }
    .img-list-tips {
      flex: 1;
      margin-left: 12px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
    }
  }
  .img-tips {
    margin-left: 8px;
    color: @primary-color;
    cursor: pointer;
  }
  .check-example {
    position: absolute;
    left: -81px;
    top: 65px;
    color: @primary-color;
    cursor: pointer;
  }
}
</style>
